// extracted by mini-css-extract-plugin
module.exports = {"nav":"nav-module--nav--1Y6fm","tab":"nav-module--tab--2AZuG","highlighted":"nav-module--highlighted--3kL4k","glow":"nav-module--glow--2hAsy"};